import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import { http } from './api'
import * as filters from './util/filters'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

http.interceptors.request.use(config => {
  config.headers = {
    'Authorization': 'Bearer ' + store.state.auth.accessToken
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

http.interceptors.response.use(response => {
   return response;
}, error => {

  if (error.response && error.response.status === 401) {
    store.dispatch('LOGOUT')
  }

  alert(error.message)

  return Promise.reject(error)
});

router.beforeEach((to, from, next) => {
  var requiresAuth = to.matched.some(record => record.meta.auth)
  var loggedIn = store.getters.isLoggedIn
  if (requiresAuth && !loggedIn) {
    next('/login')
  } else if (to.path == '/login' && loggedIn) {
    next('/')
  } else {
    next()
  }
})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
